/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM, T, useTranslate } from "@adapptio/lib-components";

import "./ReferenceGuideMain.scss";
import { ReferenceGuide } from "../../ReferenceGuide";
import { FunctionsPreview } from "../FunctionsPreview/FunctionsPreview";
import { REFERENCE_TYPE, TReferenceData } from "../../ReferenceGuideTypes";
import { ParentContent } from "./ReferenceGuideParent";
import { Markdown } from "../../../../../ui/components/Markdown";

export interface IReferenceGuideMainProps {
	className?: string;
	data: TReferenceData;
	view: ReferenceGuide;
}

export const ReferenceGuideMain: React.FC<IReferenceGuideMainProps> = ({ className, data, view }) => {
	const t = useTranslate();
	const baseClass = BEM("edt-reference-guide-main");

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()}>
			<h1>
				<T domain="editor" term={data.category} /> : <T domain="editor" term={data.label} />
			</h1>
			<Markdown>{t("editor", data.description)}</Markdown>

			{data.type === REFERENCE_TYPE.FUNCTIONS && <FunctionsPreview data={data} />}

			{data.child && <ParentContent data={data} view={view} />}
		</div>
	);
};
